import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete'

export function findPlacesByLatLng (request) {
  const geocoder = new window.google.maps.Geocoder()
  const { OK } = window.google.maps.GeocoderStatus

  return new Promise((resolve, reject) => {
    geocoder.geocode(request, (results, status) => {
      if (status !== OK) {
        return reject(status)
      }

      return resolve(results)
    })
  })
}

export function getDirectionResult (params) {
  const {
    origin,
    destination,
    travelMode = 'DRIVING',
    transitOptions,
    drivingOptions,
    unitSystem,
    waypoints,
    optimizeWaypoints,
    provideRouteAlternatives,
    avoidFerries = true,
    avoidHighways = false,
    avoidTolls = true,
    region,
  } = params
  const directionsService = new window.google.maps.DirectionsService()
  const { OK } = window.google.maps.DirectionsStatus

  const request = {
    origin,
    destination,
    travelMode,
    transitOptions,
    drivingOptions,
    unitSystem,
    waypoints,
    optimizeWaypoints,
    provideRouteAlternatives,
    avoidFerries,
    avoidHighways,
    avoidTolls,
    region,
  }

  return new Promise((resolve, reject) => {
    directionsService.route(request, (results, status) => {
      if (status !== OK) {
        return reject(status)
      }
      return resolve(results)
    })
  })
}

export function findCountry (geocodeResult) {
  const country = geocodeResult.address_components.find(a => a.types.includes('country'))
  return country ? country.short_name : 'HK'
}

export async function getOriginLatLng ({ location, address }) {
  const lat = location && location[1]
  const lng = location && location[0]

  // convert merchant adress to lat lng.
  if (!lat && !lng && address) {
    const geocodeResult = await geocodeByAddress(address)
    const latLng = await getLatLng(geocodeResult[0])
    return latLng
  }
  return { lat, lng }
}



// WEBPACK FOOTER //
// ./src/helpers/googleMap.js